import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import { featherInternalRegionIdentifier } from '..';
export var getCookieRegion = function () {
    var _a;
    return (_a = String(getCookie(featherInternalRegionIdentifier))) !== null && _a !== void 0 ? _a : '';
};
export var setCookieRegion = function (region, domain) {
    if (domain) {
        deleteCookie(featherInternalRegionIdentifier);
        setCookie(featherInternalRegionIdentifier, region, { domain: domain });
    }
    else {
        if (typeof window !== 'undefined') {
            var domainWithoutSubdomain = window.location.hostname
                .split('.')
                .slice(-2)
                .join('.');
            deleteCookie(featherInternalRegionIdentifier, {
                domain: ".".concat(domainWithoutSubdomain),
            });
        }
        setCookie(featherInternalRegionIdentifier, region);
    }
};
